import "antd/lib/config-provider/style";
import _ConfigProvider from "antd/lib/config-provider";
import React from 'react';
import * as ReactRouter from 'dva/router';
import { Route, Switch } from 'dva/router';
import IndexPage from './routes/Index/IndexPage';
import LayoutR from "./routes/Layout/Layout_R";
import MI0103R from "./routes/MI/MI0103R";
import { addLocaleData, IntlProvider } from "react-intl";
import RememberPasswordR from "./routes/Index/RemeberPasswordR";
import createHashHistory from "history/createHashHistory";
var RouterConfig = function RouterConfig() {
  addLocaleData(window.appLocale.data);
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: window.appLocale.antd
  }, /*#__PURE__*/React.createElement(IntlProvider, {
    locale: window.appLocale.locale,
    messages: window.appLocale.messages
  }, /*#__PURE__*/React.createElement(ReactRouter.Router, {
    history: createHashHistory()
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: IndexPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/rememberPwd",
    component: RememberPasswordR
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/main/mi0103",
    component: MI0103R
  }), /*#__PURE__*/React.createElement(LayoutR, null)))));
};
export default RouterConfig;